const roundSearchResultNumber = (num) => {
  let roundedNumber = num
  if (num > 50) {
    roundedNumber = '50+'
  }
  return roundedNumber
}

export default roundSearchResultNumber
